import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandMark from './BrandMark';

const Footer: React.FC = () => {
  const { pathname } = useLocation();

  const goToSection = (sectionId: string) => {
    if (pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    window.location.assign(`/#${sectionId}`);
  };

  const sectionLinks = [
    ['How it works', 'how-it-works'],
    ['Features', 'features'],
    ['Mobile', 'mobile'],
    ['Pricing', 'pricing'],
    ['FAQ', 'faq'],
  ];

  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="site-container py-10">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.5fr_0.8fr_0.8fr]">
          <div>
            <BrandMark />
            <p className="mt-4 max-w-sm text-sm leading-6 text-slate-600">
              A focused medical workspace for building a library that is organized,
              searchable, and ready wherever you learn.
            </p>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">Explore</h2>
            <ul className="mt-3 space-y-2">
              {sectionLinks.map(([label, sectionId]) => (
                <li key={sectionId}>
                  <button
                    type="button"
                    onClick={() => goToSection(sectionId)}
                    className="text-sm text-slate-600 transition-colors hover:text-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">Company</h2>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link className="text-slate-600 hover:text-emerald-700" to="/contact">Contact</Link></li>
              <li><Link className="text-slate-600 hover:text-emerald-700" to="/privacy-policy">Privacy</Link></li>
              <li><Link className="text-slate-600 hover:text-emerald-700" to="/terms-and-conditions">Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-9 flex flex-col gap-3 border-t border-slate-200 pt-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 1MEDICINE. All rights reserved.</p>
          <a
            href="https://1medicine.app"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-slate-700 hover:text-emerald-700"
          >
            Open 1MED <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
